function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/toolbar/block/blocktoolbar
 */

/* global window */
import { Plugin, icons } from 'ckeditor5/src/core';
import BlockButtonView from './blockbuttonview';
import BalloonPanelView from '../../panel/balloon/balloonpanelview';
import ToolbarView from '../toolbarview';
import clickOutsideHandler from '../../bindings/clickoutsidehandler';
import { getOptimalPosition } from '@ckeditor/ckeditor5-utils/src/dom/position';
import Rect from '@ckeditor/ckeditor5-utils/src/dom/rect';
import normalizeToolbarConfig from '../normalizetoolbarconfig';
import ResizeObserver from '@ckeditor/ckeditor5-utils/src/dom/resizeobserver';
import toUnit from '@ckeditor/ckeditor5-utils/src/dom/tounit';
var toPx = toUnit('px');
/**
 * The block toolbar plugin.
 *
 * This plugin provides a button positioned next to the block of content where the selection is anchored.
 * Upon clicking the button, a dropdown providing access to editor features shows up, as configured in
 * {@link module:core/editor/editorconfig~EditorConfig#blockToolbar}.
 *
 * By default, the button is displayed next to all elements marked in {@link module:engine/model/schema~Schema}
 * as `$block` for which the toolbar provides at least one option.
 *
 * By default, the button is attached so its right boundary is touching the
 * {@link module:engine/view/editableelement~EditableElement}:
 *
 * 		 __ |
 * 		|  ||  This is a block of content that the
 * 		 ¯¯ |  button is attached to. This is a
 * 		    |  block of content that the button is
 * 		    |  attached to.
 *
 * The position of the button can be adjusted using the CSS `transform` property:
 *
 * 		.ck-block-toolbar-button {
 * 			transform: translateX( -10px );
 * 		}
 *
 * 		 __   |
 * 		|  |  |  This is a block of content that the
 * 		 ¯¯   |  button is attached to. This is a
 * 		      |  block of content that the button is
 * 		      |  attached to.
 *
 * **Note**: If you plan to run the editor in a right–to–left (RTL) language, keep in mind the button
 * will be attached to the **right** boundary of the editable area. In that case, make sure the
 * CSS position adjustment works properly by adding the following styles:
 *
 * 		.ck[dir="rtl"] .ck-block-toolbar-button {
 * 			transform: translateX( 10px );
 * 		}
 *
 * @extends module:core/plugin~Plugin
 */

var BlockToolbar = /*#__PURE__*/function (_Plugin) {
  _inherits(BlockToolbar, _Plugin);

  var _super = _createSuper(BlockToolbar);

  /**
   * @inheritDoc
   */
  function BlockToolbar(editor) {
    var _this;

    _classCallCheck(this, BlockToolbar);

    _this = _super.call(this, editor);
    /**
     * A cached and normalized `config.blockToolbar` object.
     *
     * @type {module:core/editor/editorconfig~EditorConfig#blockToolbar}
     * @private
     */

    _this._blockToolbarConfig = normalizeToolbarConfig(_this.editor.config.get('blockToolbar'));
    /**
     * The toolbar view.
     *
     * @type {module:ui/toolbar/toolbarview~ToolbarView}
     */

    _this.toolbarView = _this._createToolbarView();
    /**
     * The balloon panel view, containing the {@link #toolbarView}.
     *
     * @type {module:ui/panel/balloon/balloonpanelview~BalloonPanelView}
     */

    _this.panelView = _this._createPanelView();
    /**
     * The button view that opens the {@link #toolbarView}.
     *
     * @type {module:ui/toolbar/block/blockbuttonview~BlockButtonView}
     */

    _this.buttonView = _this._createButtonView();
    /**
     * An instance of the resize observer that allows to respond to changes in editable's geometry
     * so the toolbar can stay within its boundaries (and group toolbar items that do not fit).
     *
     * **Note**: Used only when `shouldNotGroupWhenFull` was **not** set in the
     * {@link module:core/editor/editorconfig~EditorConfig#blockToolbar configuration}.
     *
     * **Note:** Created in {@link #afterInit}.
     *
     * @protected
     * @member {module:utils/dom/resizeobserver~ResizeObserver}
     */

    _this._resizeObserver = null; // Close the #panelView upon clicking outside of the plugin UI.

    clickOutsideHandler({
      emitter: _this.panelView,
      contextElements: [_this.panelView.element, _this.buttonView.element],
      activator: function activator() {
        return _this.panelView.isVisible;
      },
      callback: function callback() {
        return _this._hidePanel();
      }
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(BlockToolbar, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor; // Hides panel on a direct selection change.

      this.listenTo(editor.model.document.selection, 'change:range', function (evt, data) {
        if (data.directChange) {
          _this2._hidePanel();
        }
      });
      this.listenTo(editor.ui, 'update', function () {
        return _this2._updateButton();
      }); // `low` priority is used because of https://github.com/ckeditor/ckeditor5-core/issues/133.

      this.listenTo(editor, 'change:isReadOnly', function () {
        return _this2._updateButton();
      }, {
        priority: 'low'
      });
      this.listenTo(editor.ui.focusTracker, 'change:isFocused', function () {
        return _this2._updateButton();
      }); // Reposition button on resize.

      this.listenTo(this.buttonView, 'change:isVisible', function (evt, name, isVisible) {
        if (isVisible) {
          // Keep correct position of button and panel on window#resize.
          _this2.buttonView.listenTo(window, 'resize', function () {
            return _this2._updateButton();
          });
        } else {
          // Stop repositioning button when is hidden.
          _this2.buttonView.stopListening(window, 'resize'); // Hide the panel when the button disappears.


          _this2._hidePanel();
        }
      });
    }
    /**
     * Fills the toolbar with its items based on the configuration.
     *
     * **Note:** This needs to be done after all plugins are ready.
     *
     * @inheritDoc
     */

  }, {
    key: "afterInit",
    value: function afterInit() {
      var _this3 = this;

      var factory = this.editor.ui.componentFactory;
      var config = this._blockToolbarConfig;
      this.toolbarView.fillFromConfig(config, factory); // Hide panel before executing each button in the panel.

      var _iterator = _createForOfIteratorHelper(this.toolbarView.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          item.on('execute', function () {
            return _this3._hidePanel(true);
          }, {
            priority: 'high'
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (!config.shouldNotGroupWhenFull) {
        this.listenTo(this.editor, 'ready', function () {
          var editableElement = _this3.editor.ui.view.editable.element; // Set #toolbarView's max-width just after the initialization and update it on the editable resize.

          _this3._resizeObserver = new ResizeObserver(editableElement, function () {
            _this3.toolbarView.maxWidth = _this3._getToolbarMaxWidth();
          });
        });
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(BlockToolbar.prototype), "destroy", this).call(this); // Destroy created UI components as they are not automatically destroyed (see ckeditor5#1341).


      this.panelView.destroy();
      this.buttonView.destroy();
      this.toolbarView.destroy();

      if (this._resizeObserver) {
        this._resizeObserver.destroy();
      }
    }
    /**
     * Creates the {@link #toolbarView}.
     *
     * @private
     * @returns {module:ui/toolbar/toolbarview~ToolbarView}
     */

  }, {
    key: "_createToolbarView",
    value: function _createToolbarView() {
      var _this4 = this;

      var shouldGroupWhenFull = !this._blockToolbarConfig.shouldNotGroupWhenFull;
      var toolbarView = new ToolbarView(this.editor.locale, {
        shouldGroupWhenFull: shouldGroupWhenFull,
        isFloating: true
      }); // When toolbar lost focus then panel should hide.

      toolbarView.focusTracker.on('change:isFocused', function (evt, name, is) {
        if (!is) {
          _this4._hidePanel();
        }
      });
      return toolbarView;
    }
    /**
     * Creates the {@link #panelView}.
     *
     * @private
     * @returns {module:ui/panel/balloon/balloonpanelview~BalloonPanelView}
     */

  }, {
    key: "_createPanelView",
    value: function _createPanelView() {
      var _this5 = this;

      var editor = this.editor;
      var panelView = new BalloonPanelView(editor.locale);
      panelView.content.add(this.toolbarView);
      panelView.class = 'ck-toolbar-container';
      editor.ui.view.body.add(panelView);
      editor.ui.focusTracker.add(panelView.element); // Close #panelView on `Esc` press.

      this.toolbarView.keystrokes.set('Esc', function (evt, cancel) {
        _this5._hidePanel(true);

        cancel();
      });
      return panelView;
    }
    /**
     * Creates the {@link #buttonView}.
     *
     * @private
     * @returns {module:ui/toolbar/block/blockbuttonview~BlockButtonView}
     */

  }, {
    key: "_createButtonView",
    value: function _createButtonView() {
      var _this6 = this;

      var editor = this.editor;
      var t = editor.t;
      var buttonView = new BlockButtonView(editor.locale);
      buttonView.set({
        label: t('Edit block'),
        icon: icons.pilcrow,
        withText: false
      }); // Bind the panelView observable properties to the buttonView.

      buttonView.bind('isOn').to(this.panelView, 'isVisible');
      buttonView.bind('tooltip').to(this.panelView, 'isVisible', function (isVisible) {
        return !isVisible;
      }); // Toggle the panelView upon buttonView#execute.

      this.listenTo(buttonView, 'execute', function () {
        if (!_this6.panelView.isVisible) {
          _this6._showPanel();
        } else {
          _this6._hidePanel(true);
        }
      });
      editor.ui.view.body.add(buttonView);
      editor.ui.focusTracker.add(buttonView.element);
      return buttonView;
    }
    /**
     * Shows or hides the button.
     * When all the conditions for displaying the button are matched, it shows the button. Hides otherwise.
     *
     * @private
     */

  }, {
    key: "_updateButton",
    value: function _updateButton() {
      var editor = this.editor;
      var model = editor.model;
      var view = editor.editing.view; // Hides the button when the editor is not focused.

      if (!editor.ui.focusTracker.isFocused) {
        this._hideButton();

        return;
      } // Hides the button when the editor switches to the read-only mode.


      if (editor.isReadOnly) {
        this._hideButton();

        return;
      } // Get the first selected block, button will be attached to this element.


      var modelTarget = Array.from(model.document.selection.getSelectedBlocks())[0]; // Hides the button when there is no enabled item in toolbar for the current block element.

      if (!modelTarget || Array.from(this.toolbarView.items).every(function (item) {
        return !item.isEnabled;
      })) {
        this._hideButton();

        return;
      } // Get DOM target element.


      var domTarget = view.domConverter.mapViewToDom(editor.editing.mapper.toViewElement(modelTarget)); // Show block button.

      this.buttonView.isVisible = true; // Attach block button to target DOM element.

      this._attachButtonToElement(domTarget); // When panel is opened then refresh it position to be properly aligned with block button.


      if (this.panelView.isVisible) {
        this._showPanel();
      }
    }
    /**
     * Hides the button.
     *
     * @private
     */

  }, {
    key: "_hideButton",
    value: function _hideButton() {
      this.buttonView.isVisible = false;
    }
    /**
     * Shows the {@link #toolbarView} attached to the {@link #buttonView}.
     * If the toolbar is already visible, then it simply repositions it.
     *
     * @private
     */

  }, {
    key: "_showPanel",
    value: function _showPanel() {
      var wasVisible = this.panelView.isVisible; // So here's the thing: If there was no initial panelView#show() or these two were in different order, the toolbar
      // positioning will break in RTL editors. Weird, right? What you show know is that the toolbar
      // grouping works thanks to:
      //
      // * the ResizeObserver, which kicks in as soon as the toolbar shows up in DOM (becomes visible again).
      // * the observable ToolbarView#maxWidth, which triggers re-grouping when changed.
      //
      // Here are the possible scenarios:
      //
      // 1. (WRONG ❌) If the #maxWidth is set when the toolbar is invisible, it won't affect item grouping (no DOMRects, no grouping).
      //    Then, when panelView.pin() is called, the position of the toolbar will be calculated for the old
      //    items grouping state, and when finally ResizeObserver kicks in (hey, the toolbar is visible now, right?)
      //    it will group/ungroup some items and the length of the toolbar will change. But since in RTL the toolbar
      //    is attached on the right side and the positioning uses CSS "left", it will result in the toolbar shifting
      //    to the left and being displayed in the wrong place.
      // 2. (WRONG ❌) If the panelView.pin() is called first and #maxWidth set next, then basically the story repeats. The balloon
      //    calculates the position for the old toolbar grouping state, then the toolbar re-groups items and because
      //    it is positioned using CSS "left" it will move.
      // 3. (RIGHT ✅) We show the panel first (the toolbar does re-grouping but it does not matter), then the #maxWidth
      //    is set allowing the toolbar to re-group again and finally panelView.pin() does the positioning when the
      //    items grouping state is stable and final.
      //
      // https://github.com/ckeditor/ckeditor5/issues/6449, https://github.com/ckeditor/ckeditor5/issues/6575

      this.panelView.show();
      this.toolbarView.maxWidth = this._getToolbarMaxWidth();
      this.panelView.pin({
        target: this.buttonView.element,
        limiter: this.editor.ui.getEditableElement()
      });

      if (!wasVisible) {
        this.toolbarView.items.get(0).focus();
      }
    }
    /**
     * Hides the {@link #toolbarView}.
     *
     * @private
     * @param {Boolean} [focusEditable=false] When `true`, the editable will be focused after hiding the panel.
     */

  }, {
    key: "_hidePanel",
    value: function _hidePanel(focusEditable) {
      this.panelView.isVisible = false;

      if (focusEditable) {
        this.editor.editing.view.focus();
      }
    }
    /**
     * Attaches the {@link #buttonView} to the target block of content.
     *
     * @protected
     * @param {HTMLElement} targetElement Target element.
     */

  }, {
    key: "_attachButtonToElement",
    value: function _attachButtonToElement(targetElement) {
      var _this7 = this;

      var contentStyles = window.getComputedStyle(targetElement);
      var editableRect = new Rect(this.editor.ui.getEditableElement());
      var contentPaddingTop = parseInt(contentStyles.paddingTop, 10); // When line height is not an integer then thread it as "normal".
      // MDN says that 'normal' == ~1.2 on desktop browsers.

      var contentLineHeight = parseInt(contentStyles.lineHeight, 10) || parseInt(contentStyles.fontSize, 10) * 1.2;
      var position = getOptimalPosition({
        element: this.buttonView.element,
        target: targetElement,
        positions: [function (contentRect, buttonRect) {
          var left;

          if (_this7.editor.locale.uiLanguageDirection === 'ltr') {
            left = editableRect.left - buttonRect.width;
          } else {
            left = editableRect.right;
          }

          return {
            top: contentRect.top + contentPaddingTop + (contentLineHeight - buttonRect.height) / 2,
            left: left
          };
        }]
      });
      this.buttonView.top = position.top;
      this.buttonView.left = position.left;
    }
    /**
     * Gets the {@link #toolbarView} max-width, based on
     * editable width plus distance between farthest edge of the {@link #buttonView} and the editable.
     *
     * @private
     * @returns {String} maxWidth A maximum width that toolbar can have, in pixels.
     */

  }, {
    key: "_getToolbarMaxWidth",
    value: function _getToolbarMaxWidth() {
      var editableElement = this.editor.ui.view.editable.element;
      var editableRect = new Rect(editableElement);
      var buttonRect = new Rect(this.buttonView.element);
      var isRTL = this.editor.locale.uiLanguageDirection === 'rtl';
      var offset = isRTL ? buttonRect.left - editableRect.right + buttonRect.width : editableRect.left - buttonRect.left;
      return toPx(editableRect.width + offset);
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'BlockToolbar';
    }
  }]);

  return BlockToolbar;
}(Plugin);
/**
 * The block toolbar configuration. Used by the {@link module:ui/toolbar/block/blocktoolbar~BlockToolbar}
 * feature.
 *
 *		const config = {
 *			blockToolbar: [ 'paragraph', 'heading1', 'heading2', 'bulletedList', 'numberedList' ]
 *		};
 *
 * You can also use `'|'` to create a separator between groups of items:
 *
 *		const config = {
 *			blockToolbar: [ 'paragraph', 'heading1', 'heading2', '|', 'bulletedList', 'numberedList' ]
 *		};
 *
 * ## Configuring items grouping
 *
 * You can prevent automatic items grouping by setting the `shouldNotGroupWhenFull` option:
 *
 *		const config = {
 *			blockToolbar: {
 *				items: [ 'paragraph', 'heading1', 'heading2', '|', 'bulletedList', 'numberedList' ],
 *				shouldNotGroupWhenFull: true
 *			},
 *		};
 *
 * Read more about configuring the main editor toolbar in {@link module:core/editor/editorconfig~EditorConfig#toolbar}.
 *
 * @member {Array.<String>|Object} module:core/editor/editorconfig~EditorConfig#blockToolbar
 */


export { BlockToolbar as default };